<script setup lang="ts">
  import { trans } from '@bv/utils';

  import CallIntersectionAction from '../../CallIntersectionAction.vue';

  import HangupIcon from './HangupIcon.vue';
</script>

<template>
  <call-intersection-action>
    <template #icon>
      <hangup-icon />
    </template>
    <template #label>
      {{ trans('voip.calls.call_action.decline_trans') }}
    </template>
  </call-intersection-action>
</template>
